var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { PropertyModel } from '@apto/models';
import { PropertiesService, CompsService } from '@apto/services';
import { LogsService } from '@apto/ionic-lib/services';
import './stacking-plan-card.scss';
var StackingPlanCard = /** @class */ /*@__PURE__*/ (function () {
    function StackingPlanCard(logsService, propertiesService, compService) {
        this.logsService = logsService;
        this.propertiesService = propertiesService;
        this.compService = compService;
        this.addSpaceClick = new EventEmitter();
        this.openSpaceClick = new EventEmitter();
        this.stackingPlan = null;
        this.stackingPlanLoading = false;
        this.subscriptions = [];
    }
    StackingPlanCard.prototype.ngOnInit = function () {
        this.getSubscriptions();
        if (this.property && this.property._id) {
            this.loadStackingPlan(this.property._id);
        }
    };
    StackingPlanCard.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
    };
    StackingPlanCard.prototype.loadStackingPlan = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, ex_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!id) {
                            return [2 /*return*/];
                        }
                        this.stackingPlanLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.propertiesService.stackingPlan(id)];
                    case 2:
                        _a.stackingPlan = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        ex_1 = _b.sent();
                        this.logsService.error(ex_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.stackingPlanLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * reload stacking plan if comps are deleted or updated
     * reload stacking plan if spaces are deleted or updated
     */
    StackingPlanCard.prototype.getSubscriptions = function () {
        var _this = this;
        this.subscriptions.push(this.propertiesService.onDeleted.subscribe(function () { return _this.loadStackingPlan(_this.property._id || null); }, this.logsService.error), this.propertiesService.onUpserted.subscribe(function () { return _this.loadStackingPlan(_this.property._id || null); }, this.logsService.error), this.compService.onUpserted.subscribe(function () { return _this.loadStackingPlan(_this.property._id || null); }, this.logsService.error), this.compService.onDeleted.subscribe(function () { return _this.loadStackingPlan(_this.property._id || null); }, this.logsService.error));
    };
    return StackingPlanCard;
}());
export { StackingPlanCard };
